export default "__VITE_ASSET__BqTsX0TI__";